import CampaignDetails from "@/features/campaigns/components/UserCampaigns/CampaignDetails";

export default function CampaignDetailsPage() {
  return <CampaignDetails />;
}
